/**
 * User Preferences API — List a user's preferences.
 *
 * GET /v1/user-preferences[?userId=]
 *
 * Returns the stored `UserPreference` rows for the subject school-user (self,
 * or an admin's view-as target via `userId`). Flat rows of
 * { namespace, key, value }; clients interpret keys via the shared-types
 * registry for labels. Read-only.
 */

import { z } from 'zod'

import { UserPreferenceRowSchema } from '../../schemas/entities/user-preference'

export const ListUserPreferencesResponseSchema = z.object({
  preferences: z.array(UserPreferenceRowSchema)
})

export type ListUserPreferencesResponse = z.infer<typeof ListUserPreferencesResponseSchema>
